import { useIsManagedByVtex } from '~/modules/retailMedia/hooks/useIsManagedByVtex'

import { useCampaignForm } from './useCampaignForm'

/**
 * Resolves the checking account id for BalanceByPublisher on campaign create.
 *
 * - `undefined` — not managed by VTEX (legacy balance by publisher)
 * - `null` — managed by VTEX without a funding-ready PI (hide balance)
 * - `string` — managed by VTEX with PI wallet id
 */
export const useCheckingAccountIdForBalance = (): string | null | undefined => {
  const { isManagedByVtex } = useIsManagedByVtex()
  const { linkedInsertionOrder } = useCampaignForm()

  if (!isManagedByVtex) {
    return undefined
  }

  return linkedInsertionOrder?.checking_account_id || null
}
